var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIgtvVideoControls = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 347,
  height: 14,
  viewBox: "0 0 347 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("text", {
  fontFamily: "Helvetica",
  fontSize: 12,
  letterSpacing: 0.6
}, /*#__PURE__*/React.createElement("tspan", {
  x: 313.971,
  y: 11
}, "00:00")), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 14,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 14,
  x: 7,
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 7,
  r: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 262,
  height: 3,
  x: 38,
  y: 6,
  opacity: 0.3,
  rx: 1.5
}))));
export default SvgImageIgtvVideoControls;